import React from 'react'
import { inject, observer } from 'mobx-react'
import RangeSlider from 'react-range-slider-input'
import { formatNumber } from '../../utils'

const DoubleRangeSlider = ({ uiStore, id, label, inputKey, min, max, step }) => {
  const rangeFilter = uiStore.filters[inputKey]

  if (rangeFilter === undefined) {
    return null
  }

  const isDisabled = !!rangeFilter.disabled

  return (
    <div
      className={`filter__slider ${isDisabled ? 'filter__slider--disabled' : ''}`}
      style={{
        ...(isDisabled && { opacity: 0.45, pointerEvents: 'none' })
      }}
    >
      <label className='filter__trans-label text-regular' htmlFor={id}>
        <span className='filter__trans-text'>
          {label}
          {isDisabled && ' (Unavailable)'}
        </span>
        <RangeSlider
          id={id}
          min={min}
          max={max}
          step={step}
          value={rangeFilter.value}
          disabled={isDisabled}
          onInput={(val) => {
            if (isDisabled) return
            rangeFilter.setValue([Number(val[0]), Number(val[1])])
          }}
          className='filter__range-slider'
        />
      </label>

      <div className='filter__slider-min-max'>
        <span className='filter__slider-val filter__slider-val--min'>
          {formatNumber(rangeFilter.min)}
        </span>
        <span className='filter__slider-val filter__slider-val--max'>
          {formatNumber(rangeFilter.max)}
        </span>
      </div>
    </div>
  )
}

export default inject('uiStore')(observer(DoubleRangeSlider))
